import { fromJS } from "immutable";

const menuItems = fromJS(
  {
    // pages: {
    //   type:'submenu',
    //   text:'Ustawienia stron',
    //   name:'pages',
    //   icon:{
    //     className:'icon',
    //     source:'/assets/img/icon_contracts.svg'
    //   },
    //   items:{}
    // },
    // mediaCategories: {
    //   type:'submenu',
    //   text:'Media',
    //   name:'mediaCategories',
    //   icon:{
    //     className:'icon',
    //     source:'/assets/img/icon_contracts.svg'
    //   },
    //   items:{}
    // },
    // formSubmissions: {
    //   type:'menuItem',
    //   text:'Wiadomości',
    //   link:'/form-submissions',
    //   keepLinkActive:true,
    //   icon:{
    //     className:'icon',
    //     source:'/assets/img/icon_contracts.svg'
    //   },
    //   visibleFor:['developer']
    // },
    orders: {
      type: "menuItem",
      text: "Zamówienia",
      link: "/orders",
      keepLinkActive: true,
      icon: {
        className: "icon",
        source: "/assets/img/icon_shopping.svg"
      },
      visibleFor: ["admin", "developer", "user"]
    },
    news: {
      type: "menuItem",
      text: "Aktualności",
      link: "/pagesLists/aktualnosci",
      keepLinkActive: true,
      icon: {
        className: "icon",
        source: "/assets/img/icon_news.svg"
      },
      visibleFor: ["admin", "developer", "user"]
    },
    films: {
      type: "menuItem",
      text: "Filmy",
      link: "/pagesLists/films",
      keepLinkActive: true,
      icon: {
        className: "icon",
        source: "/assets/img/icon_film.svg"
      },
      visibleFor: ["admin", "developer", "user"]
    },
    kino: {
      type: "menuItem",
      text: "Kino",
      link: "/pagesLists/kino",
      keepLinkActive: true,
      icon: {
        className: "icon",
        source: "/assets/img/icon_film.svg"
      },
      visibleFor: ["admin", "developer", "user"]
    },
    menus: {
      type: "menuItem",
      text: "Menu",
      link: "/menus",
      keepLinkActive: true,
      icon: {
        className: "icon",
        source: "/assets/img/icon_menu.svg"
      },
      visibleFor: ["admin", "developer", "user"]
    },
    fieldCategories: {
      type: "menuItem",
      text: "Ustawienia",
      link: "/fieldCategories",
      keepLinkActive: true,
      icon: {
        className: "icon",
        source: "/assets/img/icon_field.svg"
      },
      visibleFor: ["admin", "developer", "user"]
    },
    team: {
      type: "menuItem",
      text: "Zespół",
      link: "/pagesLists/zespol",
      keepLinkActive: true,
      icon: {
        className: "icon",
        source: "/assets/img/icon_people.svg"
      },
      visibleFor: ["admin", "developer", "user"]
    }
  },
  function(key, value) {
    return value.toOrderedMap();
  }
);

export default menuItems;



// WEBPACK FOOTER //
// ./src/common/menu/menuItems.js